import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services';
import { LoggingService } from '../../../../framework/logging/logging.service';

@Component({
  standalone: false,
    selector: 'app-signout-callback',
    template: `
                    <div class="container-fluid">
                        <h2 class="logon-status-info">Logging Out...</h2>
                    </div>

            `
})

export class SignOutRedirectCallbackComponent implements OnInit {
    constructor(private _authService: AuthService,
                private _router: Router, private loggingService: LoggingService ) { }

    ngOnInit() {
        // console.log('🚪 SignOut callback component initializing...');
        this._authService.completeLogout().then(_ => {
            // console.log('✅ Logout completed, redirecting to login');
            this._router.navigate(['/login']);
        }).catch(error => {
            console.error('❌ Error during logout completion:', error);
            this.loggingService.logError('Logout completion error', error);
            // Still redirect to login even if logout completion fails
            this._router.navigate(['/login']);
        });
     }
}